import { UploadStatus } from "./UploadStatus";

export abstract class StatusedClass {
  public status: UploadStatus = UploadStatus.Waiting;
  public isInStatus(status: string | string[]) {
    const statuses = (Array.isArray(status) ? status : [status]) as Array<keyof typeof UploadStatus>;

    for (const statusString of statuses) {
      if (this.status === UploadStatus[statusString]) {
        return true;
      }
    }
    return false;
  }
}
